module.exports = __webpack_public_path__ + "static/media/de.e7754e88.svg";